import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { useTranslation } from 'react-i18next';

import Text from '../../../../shared/Text';

export const IncompleteTag = () => {
  const { t } = useTranslation('tiles');

  return (
    <TagWrapper>
      <TagText variant="small4">{t('incompleteTag')}</TagText>
    </TagWrapper>
  );
};

const TagWrapper = styled.div`
  padding: 3.5px 8px;
  margin-right: 6px;
  top: 68px;
  align-self: flex-end;
  position: absolute;
  background: ${themeGet('colors.error.default')};
  border-radius: 6px;
`;

const TagText = styled(Text)`
  color: white;
`;
